<template>
  <div class="grid-container full">
    <div class="grid-x page-contents-8" >
      <div class="small-12 medium-6 cell left-column">
        <h2>Our Story</h2>
        <p class="tag">
          We’ve been making the elite professions more accessible since 2005. We’ve come a long way since then: today,
          roughly one in five Magic Circle trainees is a Rare candidate.
        </p>
        <p class="standardcase">
          Two-thirds of us used to be Rare candidates or Rare clients. We know that our business is changing things for
          the better – and we won’t be satisfied until we see fair outcomes for everyone, top to bottom, in every employer we work for.
        </p>

      </div>
      <div class=" small-12 medium-6 cell text-center right-column">
        <img
          class="experinceVenGraphic"
          src="@/assets/img/icons/graduate-recruitment-experience-ven.png" alt="graduate recruitment experience ven" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RareAboutOurStory',
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  h2 {
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
  }


  @media only screen and (max-width: 640px) {
    .left-column {
      padding-right: 0;
    }

    h2 {
      font-size: 28px;
      line-height: 1.43;
      letter-spacing: 0.2px;
      margin: 38px 0 8px 0;
      text-align: center;
    }

    p.tag {
      text-align: center;
    }

    .standardcase {
      margin-bottom: 10px;
    }

    .experinceVenGraphic {
      margin: 20px 0 48px 0;
      max-height: 425px;
    }

  }

  @media only screen and (min-width: 641px) {
    .left-column {
      padding-right: 20px;
    }

    .standardcase {
      margin-bottom: 96px;
    }

    h2 {
      font-size: 56px;
      line-height: 1.29;
      letter-spacing: 0.8px;
      margin: 96px 0 20px 0;
      text-align: left;
    }
    .experinceVenGraphic {
      margin-top: 134px;
      max-height: 425px;
    }

  }


</style>



// WEBPACK FOOTER //
// src/pages/about/components/RareAboutOurStory.vue